import { AppSidebar } from "@/components/app-sidebar";
import { Button } from "@/components/ui/button";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { useFlash } from "@/hooks/use-flash";
import { useTheme } from "@/hooks/use-theme";
import { PropsWithUser } from "@/types";
import { Head, usePage } from "@inertiajs/react";
import { Moon, Sun } from "lucide-react";
import { PropsWithChildren } from "react";
import { Toaster } from "sonner";

function AppLayout({ children }: PropsWithChildren) {
  const { current_user, page_title, draft_invoices_count, flash } =
    usePage<PropsWithUser>().props;
  const { theme, toggleTheme } = useTheme();
  useFlash(flash);

  return (
    <>
      <Head title={page_title} />
      <SidebarProvider className="antialiased">
        <Toaster theme={theme} />
        <AppSidebar
          user={current_user}
          draft_invoices_count={draft_invoices_count}
        />
        <SidebarInset className="overflow-x-hidden">
          <header className="bg-background sticky top-0 z-50 flex h-14 w-full items-center justify-between gap-2 border-b px-4">
            <div>
              <SidebarTrigger />
            </div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={toggleTheme}
            >
              <Sun className="block [.dark_&]:hidden" />
              <Moon className="hidden [.dark_&]:block" />
              <span className="sr-only">Toggle theme</span>
            </Button>
          </header>
          <div className="flex-1 p-4">{children}</div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
}

export default AppLayout;
